module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_game_testing-fa62313c122d02bd2d3f3f3da5db7d99.svg";